import { render, staticRenderFns } from "./EditLabels.vue?vue&type=template&id=64867b46&scoped=true&"
import script from "./EditLabels.vue?vue&type=script&lang=ts&"
export * from "./EditLabels.vue?vue&type=script&lang=ts&"
import style0 from "./EditLabels.vue?vue&type=style&index=0&id=64867b46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64867b46",
  null
  
)

export default component.exports